import React, { useRef } from 'react';
import { useEmojisplosion } from 'src/hooks';

import { Box, Typography } from '@mui/material';
import { StepPanelHeader } from '../../../components';
import LetsConnect from 'src/features/letsConnect/LetsConnect';

import starImage from 'src/assets/passing-star.png';

export const SuccessfulSubscription: React.FC = () => {
  const starRef = useRef<HTMLDivElement>(null);
  useEmojisplosion(starRef, 'DEFAULT');

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <StepPanelHeader ref={starRef} srcSetPng={starImage} alt="Star">
        You’ve subscribed <br /> to the open position digest
      </StepPanelHeader>

      <Typography variant="body1" textAlign="center" my={4}>
        We’ll keep you posted with new <br /> exciting positions.
      </Typography>

      <LetsConnect withHeader={false} />
    </Box>
  );
};
